import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router, RouterStateSnapshot } from '@angular/router';
import { map, tap } from 'rxjs';
import { AuthenticationState } from '../enums/authentication-state.enum';
import { AuthenticationService } from '../services/authentication.service';

export const authenticationGuard: CanActivateFn = (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
  const authenticationService = inject(AuthenticationService);
  const router = inject(Router);
  return authenticationService.waitUntilReady$.pipe(
    map((state) => authenticationService.authenticationState() === AuthenticationState.Authenticated),
    tap((loggedIn) => {
      if (!loggedIn) {
        router.navigateByUrl('/onboarding');
      }
    }),
  );
};
